export default __webpack_public_path__ + "static/form-img-bc0453d983499b98eb3c721cf169f555.png";